import React, { Component } from "react";
import { connect } from "react-redux";
import QrCode from "../components/qr";

import { close_snack_bar } from "../../common/snackbar/action";

import {
  updatesQrLink,
  viewAllQr,
} from "../action";
export class Controller extends Component {
  render() {
    return <QrCode {...this.props} />;
  }
}
export const mapStateToProps = (store) => {
  return {
    login: store.login,
    loader: store.loader,
    snackbar: store.snackbar,
    QrCode: store.QrCode,
  };
};
export const mapDispatchToProps = (dispatch) => {
  return {
    
    close_snack_bar: () => {
      dispatch(close_snack_bar());
    },

    viewAllQr: (token, user_id, searchInput, page, pageSize) => {
      dispatch(viewAllQr(token, user_id, searchInput, page, pageSize));
    },

    updatesQrLink: (token, user_id, qr_id, redirectUrl) => {
      dispatch(updatesQrLink(token, user_id, qr_id, redirectUrl));
    },
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Controller);
